import type { Conversation } from '@customTypes/chat';
import { Role } from '@customTypes/types';
import {
  Avatar,
  Box,
  Divider,
  Flex,
  Group,
  Indicator,
  Text,
  Title
} from '@mantine/core';
import { useLocation, useNavigate } from '@tanstack/react-router';

import { resolveImagePath } from '@/shared/helper';

import style from './AdminConversationItem.module.css';

export const AdminConversationitem = ({
  conversation
}: {
  conversation: Conversation;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const participants = conversation.participants.filter(
    (participant) => participant?.chatProfile.profileType !== Role.admin
  );
  if (participants.length === 0) {
    return null;
  }
  return (
    <Indicator
      inline
      color={conversation.newMessageCount === 0 ? 'transparent' : ''}
      offset={20}
      position='middle-end'
      size={16}
      label={
        conversation.newMessageCount === 0 ? '' : conversation.newMessageCount
      }
    >
      <Box
        className={style.container}
        bg={
          location.href ===
          `/admin/chat/conversation/${conversation.conversationId}`
            ? 'var(--base-light-main)'
            : ''
        }
        onClick={() => {
          navigate({
            to: '/admin/chat/conversation/$conversationId',
            params: {
              conversationId: conversation.conversationId.toString()
            }
          });
        }}
      >
        <Flex align='center' gap={20}>
          {participants.length && (
            <Flex align='start' bd={1} gap={10} p={8}>
              {participants.length && (
                <Avatar.Group>
                  {participants.map((participant) => (
                    <Avatar
                      key={participant.id}
                      size='md'
                      src={
                        participant.chatProfile?.avatarUrl
                          ? resolveImagePath(participant.chatProfile?.avatarUrl)
                          : ''
                      }
                    />
                  ))}
                </Avatar.Group>
              )}

              <Flex direction='column' gap={5}>
                {participants.map((participant, index) => (
                  <Group key={participant.id} w='100%'>
                    <Title order={4}>
                      {participant.chatProfile?.displayName}
                    </Title>
                    {participants.length - 1 > index && (
                      <Divider orientation='vertical' size='xs' />
                    )}
                  </Group>
                ))}
                {conversation.isAssistanceRequested && (
                  <Text c='var(--mantine-primary-color-5)' size='xs'>
                    Need Support
                  </Text>
                )}

                {conversation.lastMessage && (
                  <Text c='gray' size='xs'>
                    {conversation.lastMessage.content.length > 10
                      ? `${conversation.lastMessage.content.slice(0, 10)}...`
                      : conversation.lastMessage.content}
                  </Text>
                )}
              </Flex>
            </Flex>
          )}
        </Flex>
      </Box>
    </Indicator>
  );
};
